<template>
  <div class="public-footer">
    <div class="footer-link">
      <div class="link-introduce">
        <p class="introduce-title">Cultural Canvas Global Stories</p>
      </div>
      <div class="link-item">
        <div class="link-item-list">
          <p class="list-title">Contact Us</p>
          <p class="list-text">Address: Xingzhihui Business Garden, No.19, Xinghuo Road, High-Tech Zone, Nanjing, P.R.China</p>
          <p class="list-text">Tel: +86-025-58745604 </p>
          <p class="list-text">Phone: 18651698553</p>
          <p class="list-text">Email: hr@istudyedu.com</p>
        </div>
        <div class="link-item-list">
          <p class="list-title">About Us</p>
          <p class="list-text">About Cultrue Vive</p>
          <p class="list-text">Cooperate with Us</p>
          <p class="list-text">News & Events</p>
          <p class="list-text">FAQ</p>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <p class="copyright-text">© 2024 Qode Interactive • all rights reserved</p>
      <div class="copyright-logo">
        <img class="logo-self" src="~@/assets/images/logo.png" alt="">
      </div>
      <p class="copyright-text right"><span class="text-a" @click="goPage('https://beian.miit.gov.cn/')">苏ICP备16041064号-14</span>南京文礼文化传媒有限公司</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'publicFooter',
  props: {},
  data () {
    return {
    }
  },
  components: {},
  computed: {},
  created () {},
  watch: {},
  methods: {
    goPage (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>
p{margin:0;padding:0;}
.public-footer{border-top:1px solid #333333;}
.public-footer .footer-link{display:flex;max-width:1800px;width:100%;margin:0 auto;align-items:center;}
.public-footer .footer-link .link-introduce{border-right:1px solid #333;padding:116px 88px 116px 0;height:auto;}
.public-footer .footer-link .link-introduce .introduce-title{font-size:32px;color:#3a4135;}
.public-footer .footer-link .link-item{display: grid;grid-template-columns:repeat(2,1fr);padding:116px 0;flex:1;}
.public-footer .footer-link .link-item .link-item-list{padding-left:150px;}
.public-footer .footer-link .link-item .link-item-list .list-title{margin-bottom:40px;font-size:18px;color:#666;}
.public-footer .footer-link .link-item .link-item-list .list-text{margin-bottom:10px;font-size:16px;color:#999;cursor:pointer;}
.public-footer .footer-copyright{border-top:1px solid #333;padding:35px 70px;display:grid;align-items:center;grid-template-columns:repeat(3,1fr);}
.public-footer .footer-copyright .copyright-logo{flex:1;}
.public-footer .footer-copyright .copyright-logo .logo-self{display:block;width:140px;margin:0 auto;}
.public-footer .footer-copyright .copyright-text{font-size:14px;color:#666;}
.public-footer .footer-copyright .copyright-text .text-a{cursor:pointer;margin-right:20px;color:#333;}
.public-footer .footer-copyright .copyright-text.right{text-align: right;}
.public-footer .footer-copyright .copyright-list{display:flex;gap:20px;justify-content:right;text-transform:uppercase;}
</style>
